// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2x33v","alert":"SettungsInbox_alert__3s40U"};